import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mantine/hooks';
import PageHeaderContext from './../pageHeaderContext.js';

// Sticky top bar: back button (mobile-only) | title | optional rightSlot.
// Lives inside the page content so it participates in that page's layout
// and transitions, instead of hanging as a global overlay. Marks itself
// as active in PageHeaderContext so the global back button in MainPage
// hides while this component is mounted (no duplicate).
const PageHeader = ({ title, rightSlot }) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery('(min-width: 48em)');
  const { setActive } = useContext(PageHeaderContext);

  useEffect(() => {
    setActive(true);
    return () => setActive(false);
  }, [setActive]);

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'var(--mantine-color-body)',
        borderBottom: '1px solid var(--mantine-color-default-border)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        minHeight: 44,
        padding: '6px 8px',
      }}
    >
      {!isDesktop ? (
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Back"
          title="Back"
          style={{
            width: 36,
            height: 36,
            flex: '0 0 36px',
            padding: 0,
            borderRadius: 999,
            border: '1px solid var(--mantine-color-default-border)',
            background: 'var(--mantine-color-default)',
            color: 'var(--mantine-color-text)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <span style={{ fontSize: 18, lineHeight: 1 }}>←</span>
        </button>
      ) : (
        <div style={{ width: 0, flex: '0 0 0' }} />
      )}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: 15,
          fontWeight: 600,
        }}
        title={typeof title === 'string' ? title : undefined}
      >
        {title}
      </div>
      {rightSlot && <div style={{ flex: '0 0 auto' }}>{rightSlot}</div>}
    </div>
  );
};

export default PageHeader;
